import { useEffect, useState } from "react";
import { LOGO_URL } from "@/lib/site-config";
import { useT } from "@/i18n/LangProvider";
import { useQuoteHref } from "@/i18n/routing";
import LanguageSwitcher from "@/components/site/LanguageSwitcher";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { t } = useT();
  const quoteHref = useQuoteHref();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const links = [
    ["offer", "oferta"],
    ["geo", "geo"],
    ["process", "processo"],
    ["portfolio", "portfolio"],
    ["faq", "faq"],
  ];

  return (
    <nav
      data-testid="site-navbar"
      className={`navbar ${scrolled ? "scrolled" : ""}`}
    >
      <div className="max-w-[1200px] mx-auto flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group flex-shrink-0"
          onClick={scrollTo("top")}
        >
          <img
            src={LOGO_URL}
            alt="Be Oasis · Web Agency"
            className="h-10 md:h-12 w-auto select-none"
            draggable="false"
          />
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {links.map(([key, id]) => (
            <a
              key={key}
              href={`#${id}`}
              onClick={scrollTo(id)}
              className="text-sm font-sans-brand text-[color:var(--muted-white)] hover:text-[color:var(--gold-light)] transition-colors"
              data-testid={`nav-link-${key}`}
            >
              {t(`nav.${key}`)}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <a
            href={quoteHref}
            className="btn-pill btn-pill-gold text-sm hidden sm:inline-flex"
            data-testid="navbar-cta-budget"
          >
            {t("nav.cta")}
          </a>
        </div>
      </div>
    </nav>
  );
}
